import { useSyncExternalStore } from 'react';
import { DIAGNOSTICS_MEDIA_SIZES } from '@/constants/diagnostics';

const subscribe = (callback: () => void) => {
  window.addEventListener('resize', callback);
  return () => window.removeEventListener('resize', callback);
};

const getSnapshot = () => document.documentElement.clientWidth <= DIAGNOSTICS_MEDIA_SIZES.sm;

const getServerSnapshot = () => false;

export function useIsSM() {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
